/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesvenues1Inputs */

const en_opportunitiesvenues1 = /** @type {(inputs: Opportunitiesvenues1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Rooms by conversion`)
};

const de_opportunitiesvenues1 = /** @type {(inputs: Opportunitiesvenues1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Rooms nach Conversion`)
};

/**
* | output |
* | --- |
* | "Live Rooms by conversion" |
*
* @param {Opportunitiesvenues1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesvenues1 = /** @type {((inputs?: Opportunitiesvenues1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesvenues1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesvenues1(inputs)
	return de_opportunitiesvenues1(inputs)
});
export { opportunitiesvenues1 as "opportunitiesVenues" }